import iconMobile from './svg/icon_mobile.svg'

interface MobileIconProps {
  className?: string
}

export function MobileIcon({ className = 'w-6 h-6' }: MobileIconProps) {
  return <img src={iconMobile} alt='Mobile' className={className} />
}
